import React, { Component } from 'react'
import InputMask from 'react-input-mask'
import { observer } from 'mobx-react';
import { COUNTRIES } from 'utils/Consts'
import Alert from 'components/Alert';
import {
    FormControl,
    Select,
    MenuItem
} from '@material-ui/core';
import 'react-dates/lib/css/_datepicker.css';
import './CustomFields.scss';

@observer
class CustomFields extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dateFocused: undefined
        }
    }

    formatDate(date) {
        const dateArr = date.split('/')
        let day, month, year;

        if (dateArr.length > 1) {
            if (dateArr[1] !== '') {
                day = Number(dateArr[0])
                day = day < 0 ? 0 : day
                day = day > 31 ? 31 : day

                day = ('00' + day)
                day = day[day.length - 2] + day[day.length - 1]
            } else {
                day = date
            }
        } else {
            day = date
        }

        if (dateArr.length > 2) {
            if (dateArr[2] !== '') {
                month = Number(dateArr[1])
                month = month < 0 ? 0 : month
                month = month > 12 ? 12 : month

                month = ('00' + month)
                month = month[month.length - 2] + month[month.length - 1]

                day = month === 2 && day > 29 ? 29 : day
                day = [4, 6, 9, 11].find(m => m === month) && day > 30 ? 30 : day

                year = Number(dateArr[2])
                year = year < 0 ? 0 : year
            } else {
                month = dateArr[1]
            }
        } else {
            month = dateArr[1]
        }

        return `${day}${month !== undefined ? '/' + month : ''}${year !== undefined ? '/' + year : ''}`
    }

    render() {
        const { props } = this
        const fields = props.fields.map((field, i) => {
            switch (field.type) {
                case 'text':
                    return (
                        <div className="group">
                            {props.showLabel ? <label>{field.title}</label> : ''}
                            <input key={field.pk_field} placeholder={props.showLabel ? undefined : field.title} className="field-text" type="text" name={field.name} onChange={e => props.onChange(e.target.value, i)} value={field.value} />
                            <div>
                                <Alert formError={!field.value ? { status: true, message: "Campo obrigatório" } : {}} />
                            </div>
                        </div>
                    )
                case 'cpf':
                    return (
                        <div className="group">
                            {props.showLabel ? <label>{field.title}</label> : ''}
                            <InputMask
                                mask="99999999999"
                                className="full-width"
                                type="text"
                                name="cpf"
                                placeholder={props.showLabel ? undefined : field.title}
                                onChange={(e) => props.onChange(e.target.value, i)}
                                value={field.value}
                                maskChar={null}
                            />
                            {!!field.validator && <div>
                                <Alert formError={field.validator(field.value) ? { status: true, message: "CPF inválido" } : {}} />
                            </div>}
                        </div>
                    )
                case 'passaporte':
                    return (
                        <div className="group">
                            {props.showLabel ? <label>{field.title}</label> : ''}
                            <input key={field.pk_field} placeholder={props.showLabel ? undefined : field.title} className="field-text" type="text" name={field.name} onChange={e => props.onChange(e.target.value, i)} value={field.value} />
                        </div>
                    )
                case 'textarea':
                    return (
                        <div className="group">
                            {props.showLabel ? <label>{field.title}</label> : ''}
                            <textarea key={field.pk_field} placeholder={props.showLabel ? undefined : field.title} className="field-text" type="text" name={field.name} onChange={e => props.onChange(e.target.value, i)} value={field.value} />
                            <div>
                                <Alert formError={field.validator(field.value) ? { status: true, message: "Campo obrigatório" } : {}} />
                            </div>
                        </div>
                    )
                case 'phone':
                    return (
                        <div className="group">
                            {props.showLabel ? <label>{field.title}</label> : ''}
                            <InputMask
                                mask="99 999999999"
                                className="full-width"
                                type="text"
                                name="phone"
                                placeholder={props.showLabel ? undefined : field.title}
                                onChange={(e) => props.onChange(e.target.value, i)}
                                value={field.value}
                                maskChar={null}
                            />
                            {!!field.validator && <div>
                                <Alert formError={field.validator(field.value) ? { status: true, message: "Numero inválido" } : {}} />
                            </div>}
                        </div>
                    )
                case 'select':
                    return (
                        <div className="group">
                            {props.showLabel ? <label>{field.title}</label> : ''}
                            <FormControl variant="outlined" className="input-outlined" style={{ width: '100%' }}>
                                <Select
                                    onChange={(e) => props.onChange(e.target.value, i)}
                                    displayEmpty
                                    value={field.value}
                                    style={{ position: 'static' }}
                                >
                                    {
                                        [props.showLabel ? '' : <MenuItem value="" disabled>{field.title}</MenuItem>,
                                        ...field.options.split(',')
                                            .map(op => <MenuItem value={op.trim()}>{op.trim()}</MenuItem>)
                                        ]
                                    }
                                </Select>
                            </FormControl>
                        </div>
                    )
                case 'estrangeiro':
                    return (
                        <div className="group">
                            {props.showLabel ? <label>{field.title}</label> : ''}
                            <FormControl variant="outlined" className="input-outlined" style={{ width: '100%' }}>
                                <Select
                                    onChange={(e) => props.onChange(e.target.value, i)}
                                    displayEmpty
                                    value={field.value}
                                >
                                    {
                                        [props.showLabel ? '' : <MenuItem value="" disabled>{field.title}</MenuItem>,
                                        ...["Sim", "Não"]
                                            .map(op => <MenuItem value={op.trim()}>{op.trim()}</MenuItem>)
                                        ]
                                    }
                                </Select>
                            </FormControl>
                        </div>
                    )
                case 'nacionalidade':
                    return (
                        <div className="group">
                            {props.showLabel ? <label>{field.title}</label> : ''}
                            <FormControl variant="outlined" className="input-outlined" style={{ width: '100%' }}>
                                <Select
                                    onChange={(e) => props.onChange(e.target.value, i)}
                                    displayEmpty
                                    value={field.value}
                                >
                                    {
                                        [props.showLabel ? '' : <MenuItem value="" disabled>{field.title}</MenuItem>,
                                        ...COUNTRIES
                                            .map(op => <MenuItem value={op.trim()}>{op.trim()}</MenuItem>)
                                        ]
                                    }
                                </Select>
                            </FormControl>
                        </div>
                    )
                case 'date':
                    return (
                        <div className="group">
                            {props.showLabel ? <label>{field.title}</label> : ''}
                            <InputMask
                                mask="99/99/9999"
                                className="full-width"
                                type="text"
                                name="cep"
                                placeholder={props.showLabel ? undefined : field.title}
                                onChange={(e) => props.onChange(this.formatDate(e.target.value), i)}
                                value={field.value}
                                maskChar={null}
                            />
                            {!!field.validator && <div>
                                <Alert formError={field.validator(field.value) ? { status: true, message: "Data inválida" } : {}} />
                            </div>}
                        </div>

                    )
                case 'birthday':
                    return (
                        <div className="group">
                            {props.showLabel ? <label>{field.title}</label> : ''}
                            <InputMask
                                mask="99/99/9999"
                                className="full-width"
                                type="text"
                                name="cep"
                                placeholder={props.showLabel ? undefined : field.title}
                                onChange={(e) => props.onChange(this.formatDate(e.target.value), i)}
                                value={field.value}
                                maskChar={null}
                            />
                            {!!field.validator && <div>
                                <Alert formError={field.validator(field.value) ? { status: true, message: "Data inválida" } : {}} />
                            </div>}
                        </div>

                    )
                case 'number':
                    return (
                        <div className="group">
                            {props.showLabel ? <label>{field.title}</label> : ''}
                            <input type="number" placeholder={props.showLabel ? undefined : field.title} className="field-number" name={field.name} value={field.value} onChange={e => props.onChange(e.target.value, i)} />
                        </div>
                    )
                case 'email':
                    return (
                        <div className="group">
                            {props.showLabel ? <label>{field.title}</label> : ''}
                            <input type="email" placeholder={props.showLabel ? undefined : field.title} className="field-email" name={field.name} value={field.value} onChange={e => props.onChange(e.target.value, i)} />
                            {!!field.validator && <div>
                                <Alert formError={field.validator(field.value) ? { status: true, message: "Email inválido" } : {}} />
                            </div>}
                        </div>
                    )
                default:
                    return ''
            }
        })

        if (props.children) {
            return props.children(fields)
        }

        return fields
    }
}


// const CustomFields = (props) => {
//     const [dateFocused, setDateFocused] = useState(undefined)
//     const fields = props.fields.map((field, i) => {
//         switch (field.type) {
//             case 'text':
//                 return (
//                     <div className="group">
//                         {props.showLabel ? <label>{field.title}</label> : ''}
//                         <input key={field.pk_field} placeholder={props.showLabel ? undefined : field.title} className="field-text" type="text" name={field.name} onChange={e => props.onChange(e.target.value, i)} value={field.value} />
//                     </div>
//                 )
//             case 'phone':
//                 return (
//                     <div className="group">
//                         {props.showLabel ? <label>{field.title}</label> : ''}
//                         <InputMask
//                             mask="(99) 99999-9999"
//                             className="full-width"
//                             type="text"
//                             name="cep"
//                             placeholder={props.showLabel ? undefined : field.title}
//                             onChange={(e) => props.onChange(e.target.value, i)}
//                             value={field.value}
//                             maskChar={null}
//                         />
//                     </div>
//                 )
//             case 'select':
//                 return (
//                     <div className="group">
//                         {props.showLabel ? <label>{field.title}</label> : '' }
//                         <FormControl variant="outlined" className="input-outlined" style={{ width: '100%' }}>
//                             <Select
//                                 onChange={(e) => props.onChange(e.target.value, i)}
//                                 displayEmpty
//                                 value={field.value}
//                             >
//                             {
//                                 [props.showLabel ? '' : <MenuItem value="" disabled>{field.title}</MenuItem>,
//                                 ...field.options.split(',')
//                                 .map(op => <MenuItem value={op.trim()}>{op.trim()}</MenuItem>)
//                                 ]
//                             }
//                             </Select>
//                         </FormControl>
//                         {/* <label>{field.title}</label>
//                         <Dropdown
//                             items={field.options.split(',').map(op => ({ name: op.trim() }))}
//                             onClickItem={(item) => props.onChange(item.name, i)}
//                             selectedValue={field.value}
//                         /> */}
//                     </div>
//                 )
//             case 'date':
//                 return (
//                     <div className="group">
//                         {props.showLabel ? <label>{field.title}</label> : ''}
//                         <SingleDatePicker
//                             date={field.value ? moment(field.value, 'DD/MM/YYYY') : undefined}
//                             placeholder={props.showLabel ? '' : field.title}
//                             focused={dateFocused}
//                             showDefaultInputIcon={false}
//                             onDateChange={date => props.onChange(date.format('DD/MM/YYYY'), i)}
//                             initialVisibleMonth={() => field.value ? moment(field.value, 'DD/MM/YYYY') : moment()}
//                             onFocusChange={({ focused }) => setDateFocused(focused)}
//                             isOutsideRange={(date) => moment(date).isBefore(new Date())}
//                             displayFormat="DD/MM/YYYY"
//                             numberOfMonths={1}
//                             orientation={HORIZONTAL_ORIENTATION}
//                         />
//                     </div>

//                 )
//             case 'number':
//                 return (
//                     <div className="group">
//                         {props.showLabel ? <label>{field.title}</label> : ''}
//                         <input type="number" placeholder={props.showLabel ? undefined : field.title} className="field-number" name={field.name} value={field.value} onChange={e => props.onChange(e.target.value, i)} />
//                     </div>
//                 )
//             case 'email':
//                 return (
//                     <div className="group">
//                         {props.showLabel ? <label>{field.title}</label> : ''}
//                         <input type="email" placeholder={props.showLabel ? undefined : field.title} className="field-email" name={field.name} value={field.value} onChange={e => props.onChange(e.target.value, i)} />
//                     </div>
//                 )
//             default:
//                 return ''
//         }
//     })

//     if (props.children) {
//         return props.children(fields)
//     }

//     return fields
// }

export default CustomFields